import { InretrnWidgetContent } from "./inreturn-widget-content";
import { getInreturnCredentials } from "../../../utils/get-inreturn-credentials";

const { inretrnUrl, inretrnToken } = getInreturnCredentials();
const returnType = "return";

export const InretrnWidget = () => {
  return (
    <InretrnWidgetContent
      scriptUrl={inretrnUrl}
      token={inretrnToken}
      returnType={returnType}
    />
  );
};
